'use strict';
define('util',['settings', 'moment'], function (settings, moment) {
	var global = {
		player: ''
	};

	function doubleDigit(no) {
		return no < 10 ? '0' + no : no;
	}

	function formatURL(url) {
		var httpPattern = /^https?:\/\//i;

		if (httpPattern.test(url)) {
			return url;
		}
		return _relativeToAbsolute(url);
	}

	function _relativeToAbsolute(relative) {
		var anchor = document.createElement('a');

		anchor.href = settings.games[0].configUrl + '/../' + relative;
		return anchor.href;
	}

	function setLocale(name) {
		moment.locale(name);
	}

	function timeRange(time) {
		return moment(time).fromNow();
	}
	function formatOdds(odds) {
		if (odds === undefined) {
			return odds;
		}
		switch (settings.games[0].oddsFormat) {
			case 'HK':
				return (parseFloat(odds) - 1);
			case 'DECIMAL':
			case 'AMERICAN':
			case 'FRACTIONAL':
			default:
				return parseFloat(odds);
		}
	}


	function formatOdd(number) {
		var scale,
			wantedLen,
			wholeDigitNum,
			formatedNumber = formatOdds(number);

		wantedLen = 3;
		wholeDigitNum = Math.floor(Math.log10(formatedNumber)) + 1;
		if (number <= 1) {
			return '-';
		}
		if (formatedNumber <= 1) {
			wantedLen--;
		}
		if (formatedNumber <= 0.1) {
			wantedLen--;
		}
		if (wholeDigitNum < wantedLen) {
			scale = Math.pow(10, wantedLen - wholeDigitNum);
			return (Math.floor((formatedNumber * scale).toPrecision(12)) / scale).toPrecision(wantedLen);
		}
		return Math.floor(formatedNumber);
	}

	function formatBid(number, gameNo) {
		var gameData = settings.games[gameNo],
			num = (number * gameData.conversionRate).toFixed(2),
			postfixes = ['', 'K', 'M', 'B', 'T'],
			thousands = 0,
			currencySymbol;

		while (num > 999) {
			num = num / 1000;
			thousands += 1;
		}

		num = parseFloat(num.toString().replace(/(\.\d{2}).*/, '$1')).toFixed(2).substr(0, 4)
			.replace(/\.$/, '') + postfixes[thousands];

		currencySymbol =
			typeof settings.local.currencyMap[gameData.currencySymbol] === 'string' ?
				settings.local.currencyMap[gameData.currencySymbol] :
				gameData.currencySymbol;

		return gameData.currencyFormat.replace(/%v/, num).replace(/%s/, currencySymbol);
	}

	function formatTime(date) {
		var monthDay = [doubleDigit(date.getMonth() + 1), doubleDigit(date.getDate())].join('.'),
			time = [
				doubleDigit(date.getHours()), doubleDigit(date.getMinutes()),
				doubleDigit(date.getSeconds())
			].join(':');

		return monthDay + ' ' + time;
	}

	function videoStreamDurationLeft(gameData) {
		const videoStartTimeOffset = 3 * 1000,
			defaultGameDuration = settings.drawingDurations[gameData.game] * 1000,
			gameStartTime = (gameData.gameStart + videoStartTimeOffset) - Date.now(),
			duration = defaultGameDuration - Math.abs(gameStartTime);

		return duration;
	}

	return {
		formatURL: formatURL,
		doubleDigit: doubleDigit,
		timeRange: timeRange,
		setLocale: setLocale,
		global: global,
		formatOdd: formatOdd,
		formatBid: formatBid,
		formatTime: formatTime,
		videoStreamDurationLeft: videoStreamDurationLeft
	};
});

